"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadForm = exports.FileUploadFormPure = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var Button_1 = require("../../Button");
var Icon_1 = require("../../Icon");
var Input_1 = require("../Input");
var handleDrop_1 = require("../../../utils/FileUpload/handleDrop");
var translation_1 = require("../../../utils/translation");
var enhancePure = (0, recompose_1.compose)((0, recompose_1.defaultProps)({
    multipleFiles: false,
    allowFolder: false
}));
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('FileUploadForm'), (0, recompose_1.withState)('inputField', 'setInputField', undefined), (0, recompose_1.withState)('inputField2', 'setInputField2', undefined), (0, recompose_1.withHandlers)({
    handleDrop: handleDrop_1.handleDrop
}), recompose_1.pure);
exports.FileUploadFormPure = enhancePure(function (props) { return (React.createElement("div", null,
    React.createElement("form", { className: 'sok-file-upload-form' },
        React.createElement("div", { className: 'sok-file-upload-form-buttons' },
            React.createElement(Button_1.Button, { size: 'large', disabled: props.disabled, className: 'text-left upload-single', icon: React.createElement(Icon_1.Icon, { className: 'fa-cloud-upload' }), text: (0, translation_1.getLocalization)('components/FileUpload/FileUploadForm/chooseFile'), onClick: function () {
                    props.inputField.click();
                } }),
            props.allowFolder && (React.createElement(Button_1.Button, { size: 'large', disabled: props.disabled, className: 'text-left upload-multiple', icon: React.createElement(Icon_1.Icon, { className: 'fa-upload' }), text: (0, translation_1.getLocalization)('components/FileUpload/FileUploadForm/chooseFolder'), onClick: function () {
                    props.inputField2.click();
                } }))),
        React.createElement(Input_1.Input, { handleDrop: props.handleDrop, multiple: props.multipleFiles, className: 'input-single', reference: function (field) { return props.setInputField(field); }, accept: props.accept })))); });
exports.FileUploadForm = enhance(exports.FileUploadFormPure);
//# sourceMappingURL=index.js.map